<template>
    <footer class="bg-[#1583d4] text-white text-center py-8 px-4 flex flex-col items-center gap-4">
        <div class="max-w-screen-xl mx-auto">
            <!-- Texto principal do copyright e branding -->
            <p class="text-sm md:text-base mb-1">
                © 2025 Senior Shopping Brasil. Todos os direitos reservados.
            </p>
            
            <!-- Linha de desenvolvimento e redes sociais -->
            <div class="flex flex-col md:flex-row items-center justify-center text-xs md:text-sm mt-1 gap-1 md:gap-3">
                <span class="text-white">Desenvolvido por
                    <a href='https://guitecnology.com.br' target='_blank'
                        class='text-yellow-300 hover:text-yellow-400 transition-colors font-bold'>
                        guitecnology
                    </a>
                </span>
                
                <a href="https://www.instagram.com/guitecnology" target="_blank" aria-label="Instagram da Guitecnology"
                   class="text-white hover:text-pink-400 transition-colors">
                    
                    <!-- Ícone do Instagram (SVG) -->
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="w-5 h-5 md:w-4 md:h-4">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                </a>
                
            </div>
            
        </div>
    </footer>
</template>

<script setup>
// Nota: Os imports e props originais foram mantidos, mas as variáveis PALETTE e enterprise não estão sendo usadas neste template, 
// então a refatoração focou apenas no layout.
import { PALETTE } from "@/constants/colors.js";

const props = defineProps({
    enterprise: {
        type: Object,
        default: () => ({}),
    },
});
</script>

<style scoped>
/* Removendo estilos inline e usando classes Tailwind para responsividade */
</style>